export function generateCollectionSessionId(collectionId, profileId) {
    if (!profileId || !collectionId) {
        return null;
    }
    return `${collectionId}_${profileId}`;
}
export function modRuleId(input) {
    return (input.type +
        "_" +
        (input.reference.tag ||
            input.reference.fileMD5 ||
            input.reference.id ||
            input.reference.logicalFileName ||
            input.reference.fileExpression ||
            input.reference.description));
}
